import { UnexpectedApiResponseError } from 'src/Libs/errors'
import { ApiResult } from 'src/Libs/api'
import { AuthFetchWithResponse } from 'src/Types/api'
import { StatusCodes } from 'src/Libs/http-status-codes'
import { SmartChargeSettingsFormModel, SmartChargeSettingsModel } from 'src/Libs/smart-charge/models'
import { SmartChargeSettingsDto } from 'src/Libs/smart-charge/dto'
import { fromSmartChargeDtoToModel, fromSmartChargeFormToUpdateDto } from 'src/Libs/smart-charge/transformers'

/**
 * Returns the Smart Home settings for a single connected storage device.
 *
 * @param serialNumber
 * @param authFetch
 */
export const getSettings = async (
  serialNumber: string,
  authFetch: AuthFetchWithResponse,
  enabled: boolean
): Promise<ApiResult<SmartChargeSettingsModel>> => {
  if (!enabled) return new ApiResult<SmartChargeSettingsModel>(null, false)
  try {
    const response = await authFetch<SmartChargeSettingsDto>({
      path: `storages/${serialNumber}/smart-functions/smart-charge`,
      method: 'GET',
    })

    if (response.status === StatusCodes.OK) {
      const model = fromSmartChargeDtoToModel(response.data as SmartChargeSettingsDto)
      return new ApiResult<SmartChargeSettingsModel>(model)
    }
    return new ApiResult<SmartChargeSettingsModel>(null, true)
  } catch (error) {
    return new ApiResult<SmartChargeSettingsModel>(null, true)
  }
}

/**
 * Updates the Smart Home settings for a single connected storage device.
 *
 * @param serialNumber
 * @param model
 * @param authFetch
 */
export const updateSettings = async (serialNumber: string, model: SmartChargeSettingsFormModel, authFetch: AuthFetchWithResponse): Promise<void> => {
  const payload = fromSmartChargeFormToUpdateDto(model)
  const response = await authFetch<void>({
    path: `storages/${serialNumber}/smart-functions/smart-charge`,
    method: 'PUT',
    payload: JSON.stringify(payload),
  })
  if (response.status !== StatusCodes.NO_CONTENT) {
    throw new UnexpectedApiResponseError(response.status)
  }
}
